import styled from '@emotion/styled';

export const ExpandedColumnItem = styled.div`
  ${({ theme }) => theme.media.showAt({ to: 1 }) `
    display: flex;
    &:not(:last-of-type) {
      margin-bottom: ${theme.spacing(1)};
    }
    & > div:last-of-type {
      max-width: 190px;
    }
  `}
  ${({ theme }) => theme.media.showAt({ from: 2 }) `
    display: inline-flex;
    min-width: 0;
    &:not(:last-of-type) {
      margin-bottom: ${theme.spacing(1)};
    }
  `}
  & > div:first-of-type {
    width: ${({ theme }) => theme.spacing(13)};
  }
`;
